module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel-content-inner platform-background rental-parameter-item height-100-p"
  }, [_c('div', {
    staticClass: "panel-header text-align-center"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('account.settings.user_platforms_section.deposit_confirmed_platforms_title')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-content form-group show m-t-25"
  }, [_c('ul', {
    staticClass: "checkbox-custom m-l-30 checkbox-primary"
  }, _vm._l((_vm.platforms), function(value, key) {
    return _c('li', {
      staticClass: "checkbox-custom checkbox-primary"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": ("platform-" + (value.id))
      },
      domProps: {
        "checked": _vm.isPlatformSelected(key)
      },
      on: {
        "change": function($event) {
          _vm.changeSelectedDepositPlatforms(key)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("platform-" + (value.id))
      }
    }, [_vm._v(_vm._s(value.toUpperCase()))])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4696c8ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/rentals/detail/depositAutoConfirmedPlatforms.vue
// module id = 1373
// module chunks = 0